const contactData = {
    data: [{
            title: 'Locations',
            name: 'Goodman road, Leyton',
            icon: 'fas fa-map-marker-alt',
        },
        {
            title: 'Opening Hours',
            name: 'Mon-Fri : 10:00 a.m - 18 p.m, Sat : 10:00 a.m - 14 p.m',
            icon: 'fas fa-clock',
        },
        {
            title: 'Number',
            name: '02071014215',
            icon: 'fas fa-phone-alt',
        },
    ],
};

export default contactData;